module.exports = __webpack_public_path__ + "img/53.e26fe5a7.png";